// Mix names are built by joining hero syllables (head, optional second head,
// torso, legs). A few combinations spell slurs, sexual terms or swear words.
// These exceptions rename them. tests/mixer-names.test.mjs checks every
// combination of both mixers, so new heroes cannot reintroduce them unnoticed.

// Whole names that get a hand-picked replacement.
export const MIX_NAME_EXCEPTIONS = {
  Retard: 'Revenzard', // Reaper or Reinhardt + Venture + Hazard (Pixel)
  Orgy: 'Orsimy', // Orisa + Sigma + Mercy (Pixel)
  Moron: 'Moiron', // Moira + Pharah/Emre/Anran + Bastion/Shion/D.Mon (Pixel)
};

// Fragments that appear across many combinations, with their repair.
export const MIX_NAME_REPAIRS = [
  [/Kike/g, 'Kirike'], // Kiriko + Junkrat + Tracer/Reaper/Cassidy/Soldier/JQ/Emre (Pixel)
  [/rape/g, 'reape'], // Orisa/Torbjörn/Freja + Reaper + e-legs (Pixel), Tracer + Reaper (Cute)
  [/tard/g, 'tazard'], // Zenyatta/Brigitte/Ramattra/Venture/Vendetta torso + Hazard legs (Pixel)
  [/porn/g, 'pjörn'], // Reaper torso + Torbjörn legs (Pixel)
  [/Shi(?=[tT])/g, 'Shion'], // Shion head before a t-syllable (both mixers)
  [/Queer/g, 'Queener'], // Junker Queen torso + Tracer/Reaper/Soldier legs (Pixel)
  [/kkk/g, 'kk'], // Wrecking Ball + Junkrat + Kiriko/Mizuki (Pixel)
  [/put(?=[ae])/g, 'paut'], // Baptiste + Mauga + ta/te legs (Pixel)
];

export function fixMixName(name) {
  if (Object.prototype.hasOwnProperty.call(MIX_NAME_EXCEPTIONS, name)) return MIX_NAME_EXCEPTIONS[name];
  return MIX_NAME_REPAIRS.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), name);
}
